import React from "react";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Portfolio from "./components/Portfolio";
import LeadForm from "./components/LeadForm";
import Footer from "./components/Footer";
import './styles/main.css';
import Navbar from "./components/Navbar";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <Portfolio />
      <WhyChooseUs />
      <LeadForm />
      <Footer />
    </div>
  );
}

export default App;
